import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import DraggableCard from "./DraggableCard";

const useStyles = makeStyles((theme) => ({
  root: () => ({
    display: "grid",
    gridTemplateColumns: "164px 164px 164px 164px",
    gridGap: 12,
    marginTop: 48,
  }),
}));

function CardList(props) {
  const { cards } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {cards.map((card) => (
        <DraggableCard key={card.name} card={card} />
      ))}
    </div>
  );
}

export default CardList;
